import React from 'react'
import TopBreadcrumb from 'components/TopBreadCrumb'
import SampleMaintenance from '../../Cockpit/SampleMaintenance/SampleMaintenanceContainer'

const Page = () => {
  const breadcrumbList = [{ name: '看板' }, { name: '操作看板' }, { name: '样本维护' }]
  return (
    <div
      style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '0 24px 24px' }}
    >
      <TopBreadcrumb breadcrumbList={breadcrumbList} />
      <SampleMaintenance paddingStyle={{ padding: 0 }} tabsStyle={{ top: -7 }} />
    </div>
  )
}

export default Page
